import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { FamilyWizardModel } from '../../models/family-wizard.model';
import { ProfessionalWizard } from '../../models/professional-wizard.model';
import { ClinicWizardModel } from '../../models/clinic-wizard.model';

export interface AppointmentWizardSettingsState {
    servicesMultiSelect: boolean /** Indica si en el asistente de pedir cita se pueden seleccionar varios servicios */;
    professionalsEnabled: boolean /** TODO: Indica si el sistema tiene las habilidades profesionales activadas ¿OBSOLETO, No se usa en cita compuesta? */;
    families: FamilyWizardModel[] /** Listado de familias disponibles para el asistente de cita */;
    professionals: ProfessionalWizard[];
    stepStack: number[] /** Pila de pasos del asistente para volver hacia atrás */;
    clinics: ClinicWizardModel[];
}

export function createInitialState(): AppointmentWizardSettingsState {
    return {
        servicesMultiSelect: null,
        professionalsEnabled: null,
        families: [],
        professionals: [],
        stepStack: [],
        clinics: [],
    };
}

/**
 * Factoría que crea una Familia para el asistente de pedir cita con los datos recogidos por la API
 */
export function familyWizardFactory(params: any) {
    return {
        id: params.FamilyId,
        sourceId: params.FamilySourceID ?? params.FamilySourceId, //TODO Lo mejor sería poner ID en mayúscula como en toda la spec de citas compuestas
        folderId: params.FamilyFolderID ?? '0',
        folderSourceId: params.FamilyFolderSourceID ?? '0',
        description: params.FamilyName,
        familiesCommonFactor: [params.FamilyId],
    } as FamilyWizardModel;
}

export function professionalWizardFactory(params: any) {
    return {
        id: params.ProfessionalId,
        description: params.ProfessionalName,
        clinic: params.ProfessionalClinicID
            ? params.ProfessionalClinicID.split(',')
            : [] /** Back me devuelve el listado como una lista de strings a diferencia de otros parámetros */,
        disabled: false,
    } as ProfessionalWizard;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'appointment-wizard-settings', resettable: true })
export class AppointmentWizardSettingsStore extends Store<
    AppointmentWizardSettingsState
> {
    constructor() {
        super(createInitialState());
    }
}
